export const cleanStreetName = (str = '') => {
  const replacedStr = str.toLowerCase().replace(/[ &#]/g, function (char) {
    return char === ' ' ? '-' : '';
  });

  return replacedStr;
};
